// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type HomeownerChangeOrderQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type HomeownerChangeOrderQuery = { __typename?: 'Query', projectEstimate: { __typename?: 'Estimate', id: string, totalPriceInCents: number, projectStage: { __typename?: 'ProjectStage', id: string, homeownerContracts: Array<{ __typename?: 'HomeownerContract', id: string, priceChangeInCents: number, changeOrders: Array<{ __typename?: 'HomeownerContractChangeOrder', id: string, priceChangeInCents: number }> }> }, lineItems: Array<{ __typename?: 'EstimateLineItem', id: string, quantity?: number | null | undefined, unitPriceInCents: number, totalPriceInCents: number, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean }, projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, specifications?: string | null | undefined, item: { __typename?: 'Item', id: string, name: string, costCode: { __typename?: 'CostCode', id: string, division: { __typename?: 'CostDivision', id: string, name: string } } }, homeownerSelection?: { __typename?: 'HomeownerSelection', id: string, selectedOption?: { __typename?: 'HomeownerSelectionOption', id: string, name: string } | null | undefined } | null | undefined } }> } };

export type HomeownerChangeOrderLineItemFragment = { __typename?: 'EstimateLineItem', id: string, quantity?: number | null | undefined, unitPriceInCents: number, totalPriceInCents: number, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean }, projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, specifications?: string | null | undefined, item: { __typename?: 'Item', id: string, name: string, costCode: { __typename?: 'CostCode', id: string, division: { __typename?: 'CostDivision', id: string, name: string } } }, homeownerSelection?: { __typename?: 'HomeownerSelection', id: string, selectedOption?: { __typename?: 'HomeownerSelectionOption', id: string, name: string } | null | undefined } | null | undefined } };

export const HomeownerChangeOrderLineItemFragmentDoc = gql`
    fragment HomeownerChangeOrderLineItem on EstimateLineItem {
  id
  quantity
  unitPriceInCents
  totalPriceInCents
  unitOfMeasure {
    id
    name
    useQuantity
  }
  projectItem {
    id
    displayName
    specifications
    item {
      id
      name
      costCode {
        id
        division {
          id
          name
        }
      }
    }
    homeownerSelection {
      id
      selectedOption {
        id
        name
      }
    }
  }
}
    `;
export const HomeownerChangeOrderDocument = gql`
    query HomeownerChangeOrder($id: ID!) {
  projectEstimate(id: $id) {
    id
    totalPriceInCents
    projectStage {
      id
      homeownerContracts {
        id
        priceChangeInCents
        changeOrders {
          id
          priceChangeInCents
        }
      }
    }
    lineItems {
      ...HomeownerChangeOrderLineItem
    }
  }
}
    ${HomeownerChangeOrderLineItemFragmentDoc}`;

/**
 * __useHomeownerChangeOrderQuery__
 *
 * To run a query within a React component, call `useHomeownerChangeOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeownerChangeOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeownerChangeOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHomeownerChangeOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HomeownerChangeOrderQuery, HomeownerChangeOrderQueryVariables> & ({ variables: HomeownerChangeOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HomeownerChangeOrderQuery, HomeownerChangeOrderQueryVariables>(HomeownerChangeOrderDocument, options);
      }
export function useHomeownerChangeOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomeownerChangeOrderQuery, HomeownerChangeOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HomeownerChangeOrderQuery, HomeownerChangeOrderQueryVariables>(HomeownerChangeOrderDocument, options);
        }
// @ts-ignore
export function useHomeownerChangeOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HomeownerChangeOrderQuery, HomeownerChangeOrderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomeownerChangeOrderQuery, HomeownerChangeOrderQueryVariables>;
export function useHomeownerChangeOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomeownerChangeOrderQuery, HomeownerChangeOrderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomeownerChangeOrderQuery | undefined, HomeownerChangeOrderQueryVariables>;
export function useHomeownerChangeOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomeownerChangeOrderQuery, HomeownerChangeOrderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HomeownerChangeOrderQuery, HomeownerChangeOrderQueryVariables>(HomeownerChangeOrderDocument, options);
        }
export type HomeownerChangeOrderQueryHookResult = ReturnType<typeof useHomeownerChangeOrderQuery>;
export type HomeownerChangeOrderLazyQueryHookResult = ReturnType<typeof useHomeownerChangeOrderLazyQuery>;
export type HomeownerChangeOrderSuspenseQueryHookResult = ReturnType<typeof useHomeownerChangeOrderSuspenseQuery>;
export type HomeownerChangeOrderQueryResult = Apollo.QueryResult<HomeownerChangeOrderQuery, HomeownerChangeOrderQueryVariables>;